import { QUERY_PARAM_TERM_UPDATED } from '../actions/constants/ActionTypes';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { validateTermOrGetDefault } from '../utils/validators';
const termFromQueryParam = getQueryParams().term;
const initialState = validateTermOrGetDefault(termFromQueryParam);

const QueryParamTerm = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case QUERY_PARAM_TERM_UPDATED:
      return payload;

    default:
      return state;
  }
};

export default QueryParamTerm;